var Config = {
    LIMIT: "10",
    PERSIST_SECRET_KEY: "123456abcdefg",
    ENVIRONMENT: "STAGING",
    ENVIRONMENTS: {
        LOCAL: {
            API_URL: "https://qa-api.casita.kodefuse.com/v1",
            DOMAIN_URL: "https://qa-app.casita.kodefuse.com",
        },
        DEVELOPMENT: {
            API_URL: "https://qa-api.casita.kodefuse.com/v1",
            DOMAIN_URL: "https://qa-app.casita.kodefuse.com",
        },
        STAGING: {
            API_URL: "https://qa-api.casita.kodefuse.com/v1",
            DOMAIN_URL: "https://qa-app.casita.kodefuse.com",
        },
        PRODUCTION: {
            API_URL: "https://qa-api.casita.kodefuse.com/v1",
            DOMAIN_URL: "https://qa-app.casita.kodefuse.com",
        },
    },
}

Config.env = () => {
    return Config.ENVIRONMENTS[Config.ENVIRONMENT]
}

export default Config